import "./Tag.css";

type TagProps = {
	children: string;
};

/** Etiqueta preta ("prevenda", "novetat") fixada no canto do bloco. */
export function Tag({ children }: TagProps) {
	return <span className="tag">{children}</span>;
}
